import React, { useContext } from "react";
import { OrdersContextProvider } from "../Context/OrdersContext";
import { Button } from "@chakra-ui/react";
import OrdersTable from "./OrdersTable";
import OrdersListMenu from "./OrdersListMenu";
import ContentCard from "../Common/Layout/ContentCard";
import { useHistory } from "react-router-dom";
import Body from "../Common/Body";
import { UsersContext } from "../Context/UsersContext";
import { userIsAllowed } from "../../Utils/userIsAllowed";

const Sales = () => {
  const history = useHistory();
  const { currentUser } = useContext(UsersContext);

  return (
    <OrdersContextProvider>
      <Body title={"Lista de pedidos"}>
        <ContentCard>
          <OrdersListMenu></OrdersListMenu>
        </ContentCard>

        <ContentCard>
          {userIsAllowed(currentUser, [11]) && (
            <Button
              my="2"
              colorScheme="blue"
              onClick={() => history.push("/pedidos/nuevo")}
            >
              + Pedido
            </Button>
          )}
          <OrdersTable></OrdersTable>
        </ContentCard>
      </Body>
    </OrdersContextProvider>
  );
};

export default Sales;
